
type EstadoComponenteProps = {
  backgroundColor: string;
  texto: string | null
}

export default function EstadoComponente(params: Readonly<EstadoComponenteProps>) {
  return (
    <div style={{
      width: '100%',
      borderRadius: '14px',
      backgroundColor: params.backgroundColor,
      border: `1px solid ${params.backgroundColor}`,
      padding: '5px',
      color: "white",
      fontWeight: 'initial',
    }}>
      <p style={{ textAlign: 'center' }}>{params.texto}</p>
    </div>
  );
}